import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-dialog-aguarde',
  standalone: true,
  templateUrl: './dialog-aguarde.component.html',
  styleUrls: ['./dialog-aguarde.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    DialogModule,
    ProgressBarModule
  ]
})
export class DialogAguardeComponent {
  @Input() visible: boolean = false;
}
